import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-7" data-id="element-175" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-176" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-2xl leading-none text-forest sm:text-4xl" data-id="element-177" data-mp="3fxuni758astw">
          What agricultural professionals <span className="text-leaf" data-id="element-178" data-mp="3ayqdjeahcr2i">are saying</span>
        </h2>
        <p className="mt-1 text-center text-xs italic text-ink/70" data-id="element-179" data-mp="36zr3jf9w6447">
          Illustrative testimonial placeholders. Replace with verified customer reviews before
          publishing.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-180" data-mp="2x1l2ezvwt20e">
          {testimonials.map((testimonial, i) => <article key={testimonial.name} className={`flex flex-col rounded-lg border border-forest/15 bg-white p-3 shadow-sm sm:p-4 ${i === 0 ? 'border-l-4 border-l-gold md:col-span-2' : ''}`} data-id="element-181" data-mp="2s3t8k0bpf5tk" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-182" data-mp="h559pzvzjrw1">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-gold" fill="currentColor" strokeWidth={0} aria-hidden="true" data-id="element-183" data-mp="m2omevd1bwlv" />)}
              </div>
              <h3 className="mt-1 text-sm normal-case leading-tight text-forest sm:text-base" data-id="element-184" data-mp="zx7sphw3nk9g">
                “{testimonial.headline}”
              </h3>
              <p className="mt-1 text-sm leading-snug text-ink" data-id="element-185" data-mp="q762ajg9xprd">“{testimonial.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-2" data-id="element-186" data-mp="v5fy8w9toue1">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-extrabold text-white" aria-hidden="true" data-id="element-187" data-mp="v3d0tr6cbyza">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-188" data-mp="1xfwjesbi8wyd">
                  <p className="font-display text-sm font-bold leading-none text-forest" data-id="element-189" data-mp="1sj5vxjxdez2x">
                    — {testimonial.role} · {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="mt-0.5 text-xs text-ink/80" data-id="element-190" data-mp="1ji80hq0zzzvy">{testimonial.location}</p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}